import { apiGet } from './client';

export async function getStoreImage(storeId: string): Promise<{ storeImage: string | null }> {
  try {
    return await apiGet<{ storeImage: string | null }>(
      `/api/stores/${encodeURIComponent(storeId)}/image`,
    );
  } catch {
    return { storeImage: null };
  }
}
